import { render } from "./RejectAllSpeakersModal.vue?vue&type=template&id=2c6866ad"
import script from "./RejectAllSpeakersModal.vue?vue&type=script&lang=js"
export * from "./RejectAllSpeakersModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Ibrahim\\Documents\\uat-frontend-saxton\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__